import * as React from 'react';
import styled from 'styled-components';

import { BREAK_POINTS } from '../../consts/styleDedupe';

interface ISectionProps {
  children: React.ReactNode;
  bgColor?: string;
  padding?: boolean;
}

type SectionOuterProps = {
  padding: boolean;
};

const SectionOuter = styled.div`
  ${(p: SectionOuterProps) =>
    p.padding &&
    `
  padding: 64px 24px 72px;
  overflow: hidden;

  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    padding: 64px 80px 72px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 64px 40px 72px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    padding: 96px 48px 108px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.XL}) {
    padding: 96px 0 108px;
  }
  `}
`;

const SectionInner = styled.div`
  @media screen and (min-width: ${BREAK_POINTS.Min.XL}) {
    max-width: 1108px;
    margin: 0 auto;
  }
`;

export const Section = ({ bgColor = 'white', padding = true, children }: ISectionProps) => {
  return (
    <SectionOuter data-id="section" padding={padding} style={{ backgroundColor: bgColor }}>
      <SectionInner>{children}</SectionInner>
    </SectionOuter>
  );
};
